export const countryCodes = [
    'AL',
    'AD',
    'AM',
    'AT',
    'AZ',
    'BY',
    'BE',
    'BA',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'GE',
    'DE',
    'GR',
    'HU',
    'IS',
    'IE',
    'IT',
    'KZ',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MD',
    'MC',
    'ME',
    'NL',
    'MK',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SM',
    'RS',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'TR',
    'UA',
    'GB',
    'VA',
] as const;

export type CountryCode = (typeof countryCodes)[number];

const ISO3ToISO2CountryCode: Record<string, CountryCode> = {
    ALB: 'AL',
    AND: 'AD',
    ARM: 'AM',
    AUT: 'AT',
    AZE: 'AZ',
    BLR: 'BY',
    BEL: 'BE',
    BIH: 'BA',
    BGR: 'BG',
    HRV: 'HR',
    CYP: 'CY',
    CZE: 'CZ',
    DNK: 'DK',
    EST: 'EE',
    FIN: 'FI',
    FRA: 'FR',
    GEO: 'GE',
    DEU: 'DE',
    GRC: 'GR',
    HUN: 'HU',
    ISL: 'IS',
    IRL: 'IE',
    ITA: 'IT',
    KAZ: 'KZ',
    LVA: 'LV',
    LIE: 'LI',
    LTU: 'LT',
    LUX: 'LU',
    MLT: 'MT',
    MDA: 'MD',
    MCO: 'MC',
    MNE: 'ME',
    NLD: 'NL',
    MKD: 'MK',
    NOR: 'NO',
    POL: 'PL',
    PRT: 'PT',
    ROU: 'RO',
    RUS: 'RU',
    SMR: 'SM',
    SRB: 'RS',
    SVK: 'SK',
    SVN: 'SI',
    ESP: 'ES',
    SWE: 'SE',
    CHE: 'CH',
    TUR: 'TR',
    UKR: 'UA',
    GBR: 'GB',
    VAT: 'VA',
};

export const getAllISO3CountryCodes = (): string[] => {
    return Object.keys(ISO3ToISO2CountryCode);
};

export const mapCountryCodeISO3ToISO2 = (iso3: string | undefined): string | undefined => {
    if (iso3 === undefined) {
        return undefined;
    }
    return ISO3ToISO2CountryCode[iso3];
};
